module.exports = __webpack_public_path__ + "static/media/home.45e6136.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/home.mp4
// module id = N0MZ
// module chunks = 3